import {
  GET_ODONTOGRAM_HISTORY_REQUEST,
  GET_ODONTOGRAM_HISTORY_SUCCESS,
  GET_ODONTOGRAM_HISTORY_FAIL,
  SAVE_ODONTOGRAM_REQUEST,
  SAVE_ODONTOGRAM_SUCCESS,
  SAVE_ODONTOGRAM_FAIL,
  UPDATE_ODONTOGRAM_REQUEST,
  UPDATE_ODONTOGRAM_SUCCESS,
  UPDATE_ODONTOGRAM_FAIL,
  DELETE_ODONTOGRAM_REQUEST,
  DELETE_ODONTOGRAM_SUCCESS,
  DELETE_ODONTOGRAM_FAIL,
  CLEAR_ODONTOGRAM_DATA,
  GET_LIST_PATIENT_VITALSIGN_REQUEST,
  GET_LIST_PATIENT_VITALSIGN_SUCCESS,
  GET_LIST_PATIENT_VITALSIGN_FAIL,
  DOWNLOAD_ODONTOGRAM_USER_GUIDANCE_REQUEST,
  DOWNLOAD_ODONTOGRAM_USER_GUIDANCE_SUCCESS,
  DOWNLOAD_ODONTOGRAM_USER_GUIDANCE_FAIL
} from '../../constants/odontogram'

const initialState = {
  historyData: [],
  currentOdontogram: null,
  listPatientVitalsign: [],
  loadingHistory: false,
  loadingSave: false,
  loadingUpdate: false,
  loadingDelete: false,
  loadingListPatientVitalsign: false,
  loadingDownloadUserGuidance: false,
  error: null
}

const odontogramReducer = (state = initialState, action) => {
  switch (action.type) {
    // History
    case GET_ODONTOGRAM_HISTORY_REQUEST:
      return { ...state, loadingHistory: true, error: null }
    case GET_ODONTOGRAM_HISTORY_SUCCESS:
      return { ...state, loadingHistory: false, historyData: action.payload }
    case GET_ODONTOGRAM_HISTORY_FAIL:
      return { ...state, loadingHistory: false, error: action.payload }

    // Save
    case SAVE_ODONTOGRAM_REQUEST:
      return { ...state, loadingSave: true, error: null }
    case SAVE_ODONTOGRAM_SUCCESS:
      return { ...state, loadingSave: false, currentOdontogram: action.payload }
    case SAVE_ODONTOGRAM_FAIL:
      return { ...state, loadingSave: false, error: action.payload }

    // Update
    case UPDATE_ODONTOGRAM_REQUEST:
      return { ...state, loadingUpdate: true, error: null }
    case UPDATE_ODONTOGRAM_SUCCESS:
      return { ...state, loadingUpdate: false, currentOdontogram: action.payload }
    case UPDATE_ODONTOGRAM_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }

    // Delete
    case DELETE_ODONTOGRAM_REQUEST:
      return { ...state, loadingDelete: true, error: null }
    case DELETE_ODONTOGRAM_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        historyData: state.historyData.filter(item => item.id !== action.payload)
      }
    case DELETE_ODONTOGRAM_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }

    // Patient Vital Sign List
    case GET_LIST_PATIENT_VITALSIGN_REQUEST:
      return { ...state, loadingListPatientVitalsign: true, error: null }
    case GET_LIST_PATIENT_VITALSIGN_SUCCESS:
      return { ...state, loadingListPatientVitalsign: false, listPatientVitalsign: action.payload }
    case GET_LIST_PATIENT_VITALSIGN_FAIL:
      return { ...state, loadingListPatientVitalsign: false, error: action.payload }

    // Download user guidance
    case DOWNLOAD_ODONTOGRAM_USER_GUIDANCE_REQUEST:
      return { ...state, loadingDownloadUserGuidance: true, error: null }
    case DOWNLOAD_ODONTOGRAM_USER_GUIDANCE_SUCCESS:
      return { ...state, loadingDownloadUserGuidance: false }
    case DOWNLOAD_ODONTOGRAM_USER_GUIDANCE_FAIL:
      return { ...state, loadingDownloadUserGuidance: false, error: action.payload }

    // Clear
    case CLEAR_ODONTOGRAM_DATA:
      return initialState

    default:
      return state
  }
}

export default odontogramReducer
